
import { PrismicTagType } from '@/constants/prismicContent';
import { getAction, SET_CONTENT_DATA } from '@/store/contact/actions';
import PrismicRequestsHelper from '@/utils/PrismicRequestsHelper';
import ContactPageStoreName from '@/store/contact/name';
import MetaHead from '@/mixins/MetaHead';
import OfficeSection from '@/components/page-specific/contact/office-section';
import ContactCards from '@/components/page-specific/contact/contact-cards';
import HeroSection from '@/components/marketing/hero';

export default {
  name: 'ContactPage',
  components: {
    HeroSection,
    ContactCards,
    OfficeSection,
  },
  mixins: [MetaHead],
  data: () => ({
    isInitialized: false,
    ContactPageStoreName,
  }),
  async fetch() {
    if (this.isContentLoaded) {
      return;
    }
    const data = await this.getContent();

    this.meta.title = data.meta_title;
    this.meta.description = data.meta_description;
    this.meta.image = data.meta_image;
    await this.$store.dispatch(getAction(SET_CONTENT_DATA), data);
  },
  computed: {
    isContentLoaded() {
      return this.$store.state[ContactPageStoreName].isContentLoaded;
    },
  },
  methods: {
    getContent() {
      const prismicRequestsHelper = new PrismicRequestsHelper(this.$prismic);
      return prismicRequestsHelper.getDocument(PrismicTagType.NewContactPage);
    },
  },
};
